import type { Dispatch } from "react";
import type { EditorAction, EditorState, RegionMode } from "../editor/reducers";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@acdc2/ui/components/tabs";
import { mdiVectorPolygonVariant, mdiVectorSquare } from "@mdi/js";

type Props = {
  state: EditorState;
  dispatch: Dispatch<EditorAction>;
};

export function RegionsToolbox({ state, dispatch }: Props) {
  const { t } = useTranslation();

  const onValueChange = (mode: string) => {
    dispatch({ type: "switchMode", mode: mode as RegionMode });
  };

  return (
    <Tabs value={state.mode} onValueChange={onValueChange}>
      <TabsList className="w-full grid grid-cols-2">
        <TabsTrigger value={"rectangle" satisfies RegionMode}>
          <Icon path={mdiVectorSquare} />
          <span className="ml-2">{t("RegionsToolbox.rectangle.label")}</span>
        </TabsTrigger>
        <TabsTrigger value={"polygon" satisfies RegionMode}>
          <Icon path={mdiVectorPolygonVariant} />
          <span className="ml-2">{t("RegionsToolbox.polygon.label")}</span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
